import React from 'react';
import { Navbar, Nav, Dropdown, Button } from 'react-bootstrap';
import { Link, usePage, useForm } from '@inertiajs/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faUser } from '@fortawesome/pro-regular-svg-icons';
import Logo from '../../images/logo.png';
import { Role } from '../Data/Role';

interface ToggleProps {
	children: any;
	onClick: any;
}

// override classes assigned to the toggle but keep the scripting
const CustomToggle = React.forwardRef(
	({ children, onClick }: ToggleProps, ref: any) => (
		<a
			href=''
			className='nav-link user-profile-icon'
			ref={ref}
			onClick={(e) => {
				e.preventDefault();
				onClick(e);
			}}
		>
			{children}
		</a>
	),
);
CustomToggle.displayName = 'CustomToggle';

const TopNav = () => {
	const { user, agencyAnalystEmail } = usePage<any>().props;
	const { post } = useForm();

	const contactHref = agencyAnalystEmail
		? `mailto:${agencyAnalystEmail}`
		: 'https://iavaluations.com/contact/';
	const contactTarget = agencyAnalystEmail ? undefined : '_blank';

	const userButtons = (
		<div className='d-flex align-items-center gap-3'>
			<Button
				as={Link as any}
				href='/profile'
				variant='primary'
				className='d-flex align-items-center gap-2'
			>
				<FontAwesomeIcon icon={faCog} />
				<span>Manage Profile</span>
			</Button>
			<Button
				as={Link as any}
				href='/logout'
				method='post'
				variant='outline-primary'
				className='px-7'
			>
				Log Out
			</Button>
		</div>
	);

	return (
		<Navbar
			expand='lg'
			className='top-nav align-items-center py-0'
		>
			<Navbar.Brand href='/'>
				<img
					src={Logo}
					className='d-inline-block align-top'
					alt='IA Valuations Logo'
				/>
			</Navbar.Brand>
			{user && (
				<div className='d-lg-none ms-auto pe-2'>{userButtons}</div>
			)}
			<Navbar.Toggle aria-controls='mobile-nav' />
			<Navbar.Collapse id='mobile-nav'>
				<Nav className='w-100 justify-content-between align-items-center'>
					<div className='d-flex flex-column flex-lg-row align-items-center gap-5 ms-10'>
						<Nav.Link
							href='/'
							active={window.location.pathname === '/'}
						>
							Dashboard
						</Nav.Link>
						{user.role == Role.user && (
							<Nav.Link href={contactHref} target={contactTarget}>Contact Us</Nav.Link>
						)}
						{user.role == Role.admin && (
							<Nav.Link href='/admin'>Admin</Nav.Link>
						)}
					</div>
					<div className='d-flex flex-column flex-lg-row align-items-center'>
						{user && (
							<div className='d-none d-lg-flex'>
								{userButtons}
							</div>
						)}
					</div>
				</Nav>
			</Navbar.Collapse>
		</Navbar>
	);
};

export default TopNav;
